<template>
  <modal ref="modal" @before-open="setFields" @close="reset">
    <span slot="activator">
      <slot name="activator"></slot>
    </span>
    <div v-if="mode == 'create'" slot="header">Create a new address</div>
    <div v-else slot="header">Edit address</div>
    <div slot="toolbar" class="ui left aligned">
      <button
        v-if="mode == 'create'"
        :class="{ loading: loading }"
        :disabled="loading"
        class="ui button green"
        @click="createAddress"
      >
        Create
      </button>
      <button
        v-if="mode == 'create'"
        :disabled="loading"
        class="ui button yellow"
        @click="loadShopAddress"
      >
        Load shop address
      </button>
      <button
        v-else
        :class="{ loading: loading }"
        :disabled="loading"
        class="ui button green"
        @click="updateAddress"
      >
        Save
      </button>
    </div>
    <div class="content">
      <vertical-table
        :columns="address_columns"
        name_class="four wide"
        table_class="ui celled table"
      >
        <span
          v-for="(element, index) in address_columns"
          :key="index"
          :slot="element.id"
        >
          <span v-if="errors.first(element.name)" class="error">{{
            errors.first(element.name)
          }}</span>
          <div
            v-if="element.id == 'id_country'"
            class="four wide column center aligned"
          >
            <select
              v-model="address[element.id]"
              class="ui fluid dropdown selection"
              style="height: 48px"
            >
              <option
                v-for="country in countries"
                :key="country.id"
                :value="country.id"
              >
                {{ country.name }}
              </option>
            </select>
          </div>
          <div
            v-else
            :class="{ error: errors.first(element.name) }"
            class="ui fluid input"
          >
            <input
              :name="element.name"
              v-validate="element.validator"
              v-model="address[element.id]"
              placeholder
            />
          </div>
        </span>
      </vertical-table>
    </div>
  </modal>
</template>

<style scoped>
.error {
  color: #c00;
}
</style>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Address',
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    address_to_edit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      address: {
        company: null,
        alias: null,
        id_customer: null,
        id_country: 8,
        firstname: '',
        lastname: '',
        address1: '',
        address2: '',
        postcode: '',
        city: '',
        phone: '',
        phone_mobile: ''
      },
      address_columns: [
        {
          id: 'company',
          name: 'Company',
          validator: ''
        },
        {
          id: 'alias',
          name: 'Alias',
          validator: 'required'
        },
        {
          id: 'id_country',
          name: 'Country',
          validator: 'required'
        },
        {
          id: 'firstname',
          name: 'Firstname',
          validator: 'required'
        },
        {
          id: 'lastname',
          name: 'Lastname',
          validator: 'required'
        },
        {
          id: 'address1',
          name: 'Street',
          validator: 'required'
        },
        {
          id: 'address2',
          name: 'Street (more)',
          validator: ''
        },
        {
          id: 'postcode',
          name: 'Postcode',
          validator: 'required|numeric'
        },
        {
          id: 'city',
          name: 'City',
          validator: 'required'
        },
        {
          id: 'phone',
          name: 'Phone',
          validator: ''
        },
        {
          id: 'phone_mobile',
          name: 'Phone (Mobile)',
          validator: 'required'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries',
      currentCustomer: 'getCurrentCustomer',
      shopAddress: 'getShopAddress'
    })
  },
  methods: {
    loadShopAddress() {
      this.address = {
        id_customer: this.currentCustomer.id,
        firstname: this.currentCustomer.firstname,
        lastname: this.currentCustomer.lastname,
        phone: this.address ? this.address.phone : null,
        phone_mobile: this.address ? this.address.phone_mobile : null,
        company: this.shopAddress.company,
        alias: this.shopAddress.alias,
        id_country: this.shopAddress.id_country,
        address1: this.shopAddress.address1,
        address2: this.shopAddress.address2,
        postcode: this.shopAddress.postcode,
        city: this.shopAddress.city
      }
    },
    createAddress() {
      this.$validator.validate().then((result) => {
        if (!result) {
          return
        }
        this.address.id_customer = this.currentCustomer.id
        this.loading = true
        axios
          .post('/addresses', this.address)
          .then((response) => {
            this.loading = false
            // Emit the event and close the modal when axios finished.
            const { address } = response.data
            this.$store.dispatch('createAddress', address)
            this.$emit('input', address)
            this.$refs.modal.close()
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e)
            this.loading = false
          })
        // TODO: Deal with errors
      })
    },
    updateAddress() {
      this.$validator.validate().then((result) => {
        if (!result) {
          return
        }
        this.address.id_customer = this.currentCustomer.id
        this.loading = true
        axios
          .put(`/addresses/${this.address.id}`, this.address)
          .then((response) => {
            this.loading = false
            // Emit the event and close the modal when axios finished.
            const { address } = response.data
            this.$emit('input', address)
            this.$refs.modal.close()
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e)
            this.loading = false
          })
        // TODO: Deal with errors
      })
    },
    reset() {
      this.address = {
        id_country: 8,
        id_customer: this.currentCustomer.id,
        firstname: this.currentCustomer.firstname,
        lastname: this.currentCustomer.lastname
      }
    },
    setFields() {
      if (!this.address_to_edit) {
        this.reset()
        return
      }
      this.address = { ...this.address_to_edit }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddressModal.vue?7835e6b4